module.exports = __webpack_public_path__ + "img/nissan-Worth.c4029bb1.png";